import React, { Component } from 'react';
import history from '../../history';

export class PriorityHostingBanner extends Component {
    navigateToDashboard = () => {
        history.push('/dashboard');
    };

    navigateToPrioHosting = () => {
        history.push('/dashboard/priohosting');
    };

    render() {
        return (
            <div className="relative overflow-hidden bg-[#1A1A2E] p-6 sm:p-12 rounded-2xl my-4 text-white">
                {/* Dark gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A2E] via-[#1F2D2B] to-[#1A1A2E]" />

                {/* Enhanced Glow Effects */}
                <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#00ffe0]/30 via-[#00ccb3]/20 to-transparent blur-3xl animate-pulse" />
                <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#00ffe0]/25 via-[#00ccb3]/15 to-transparent blur-2xl animate-pulse" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#00ffe0]/[0.05] to-[#00ccb3]/[0.08]" />

                {/* Priority Badge */}
                <div className="absolute -right-12 -top-12 w-48 h-48 rotate-12">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#00ffe0] to-[#00ccb3] rounded-full opacity-20 animate-pulse"></div>
                    <div className="absolute inset-2 bg-gradient-to-br from-[#00ffe0] to-[#00ccb3] rounded-full opacity-20 animate-pulse delay-100"></div>
                    <div className="absolute inset-4 bg-gradient-to-br from-[#00ffe0] to-[#00ccb3] rounded-full opacity-20 animate-pulse delay-200"></div>
                </div>

                <div className="flex flex-col lg:flex-row items-center justify-between relative z-10 gap-8 lg:gap-0">
                    {/* Content */}
                    <div className="relative z-10 w-full lg:max-w-xl">
                        <div className="flex items-center gap-4 mb-3">
                            <h1 className="text-3xl sm:text-4xl font-bold">
                                Enterprise Priority Hosting
                            </h1>
                            <div className="animate-bounce">
                                <span className="inline-flex items-center px-4 py-1 rounded-full text-lg font-bold bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] text-black shadow-lg shadow-[#00ffe0]/30">
                                    ACTIVE
                                </span>
                            </div>
                        </div>

                        <div className="text-2xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]">
                            Your Bot is Running on Enterprise-Grade Hardware!
                        </div>

                        <p className="text-base sm:text-lg leading-relaxed text-gray-100 mb-5 lg:pr-12">
                            Your bot is now running on <span className="font-bold text-[#00ffe0]">priority hosting</span> which includes <span className="font-bold text-[#00ccb3]">faster response times</span>, <span className="font-bold text-[#00ffe0]">dedicated resources</span>, and <span className="font-bold text-[#00ccb3]">premium support</span>. Enjoy AWS m8g.8xlarge performance with only ~10 bots per instance for maximum reliability, especially beneficial for high-traffic bots in thousands of servers!
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={this.navigateToPrioHosting}
                                className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                    transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                    group cursor-pointer"
                            >
                                {/* Gradient background */}
                                <div className="absolute inset-0 bg-gradient-to-r from-[#00ffe0] via-[#00d9c4] to-[#00ccb3]
                                    group-hover:opacity-90 transition-opacity" />

                                {/* Shine effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                    translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                                {/* Button shadow */}
                                <div className="absolute inset-0 shadow-xl shadow-[#00ffe0]/20" />

                                {/* Button text */}
                                <span className="relative z-10 flex items-center justify-center gap-2 text-black">
                                    Enterprise Hosting Details
                                </span>
                            </button>


                        </div>
                    </div>

                    {/* Priority Icon - Hidden on mobile */}
                    <div className="hidden lg:block relative z-10 w-[150px] mr-16">
                        <div className="animate-bounce glow-cyan">
                            <img
                                src={process.env.PUBLIC_URL + '/images/icons/prio_hosting_role.png'}
                                alt="Priority Hosting"
                                className="w-36 h-36 object-contain rounded-full border-4 border-white/50 shadow-lg"
                            />
                            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] rounded-full px-3 py-1 text-sm font-bold text-black shadow-lg shadow-[#00ffe0]/30 animate-pulse">
                                Enterprise
                            </div>
                        </div>
                    </div>
                </div>

                {/* Floating stars decoration */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
                    <div className="absolute top-2 right-[5%] text-[#00ffe0]/30 text-3xl animate-pulse delay-100">✦</div>
                    <div className="absolute top-16 right-[15%] text-[#00ffe0]/40 text-2xl animate-pulse delay-300">✧</div>
                    <div className="absolute top-4 right-[25%] text-[#00ffe0]/30 text-3xl animate-pulse delay-500">✦</div>
                    <div className="absolute top-20 right-[35%] text-[#00ffe0]/40 text-2xl animate-pulse delay-700">✧</div>
                </div>

                <style jsx>{`
                    .glow-cyan {
                        filter: drop-shadow(0 0 10px rgba(0, 255, 224, 0.3));
                    }
                `}</style>
            </div>
        );
    }
}

export default PriorityHostingBanner; 